(function(){
  var SELECTOR = '#dispatch-countdown';

  function fmtParts(d, tz){
    var fmt = new Intl.DateTimeFormat('en-AU',{
      timeZone: tz, hour12: false,
      year:'numeric', month:'2-digit', day:'2-digit',
      hour:'2-digit', minute:'2-digit', second:'2-digit'
    }).formatToParts(d);
    var o={}; fmt.forEach(function(p){ if(p.type!=='literal') o[p.type]=p.value; });
    return { y:+o.year, m:+o.month, d:+o.day, H:+o.hour, M:+o.minute, S:+o.second };
  }
  function weekdayIdx(d, tz){
    var name = new Intl.DateTimeFormat('en-AU',{ timeZone: tz, weekday:'short' }).format(d);
    return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(name);
  }
  function toUtcMs(p){ return Date.UTC(p.y, p.m-1, p.d, p.H, p.M, p.S); }

  function nextBusinessCutoff(from, tz, cutoffHour){
    var parts = fmtParts(from, tz);
    var wd = weekdayIdx(from, tz);
    var afterCutoff = parts.H > cutoffHour || (parts.H === cutoffHour && (parts.M>0 || parts.S>0));
    var probe = new Date(from);
    if(afterCutoff || wd===0 || wd===6){
      do { probe = new Date(probe.getTime()+86400000); wd = weekdayIdx(probe, tz); }
      while(wd===0 || wd===6);
      parts = fmtParts(probe, tz);
    }
    return Date.UTC(parts.y, parts.m-1, parts.d, cutoffHour, 0, 0);
  }

  function init(el){
    if(!el || el.dataset.inited) return;
    el.dataset.inited = '1';

    var TZ = el.dataset.timezone || 'Australia/Sydney';
    var CUTOFF = Number(el.dataset.cutoff || 17);
    var timerEl = el.querySelector('[data-timer]');
    var labelEl = el.querySelector('[data-label]');
    var intervalId;

    function tick(){
      var now = new Date();
      var p = fmtParts(now, TZ);
      var nowSydneyMs = toUtcMs({y:p.y,m:p.m,d:p.d,H:p.H,M:p.M,S:p.S});
      var targetMs = nextBusinessCutoff(now, TZ, CUTOFF);
      var diff = targetMs - nowSydneyMs;

      if(diff <= 0){ el.style.display='none'; if(intervalId) clearInterval(intervalId); return; }

      var h = Math.floor(diff/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);
      timerEl.textContent = h+'h '+m+'m '+s+'s';

      var todayCutoffMs = Date.UTC(p.y, p.m-1, p.d, CUTOFF, 0, 0);
      var wd = weekdayIdx(now, TZ);
      var sameDay = wd>=1 && wd<=5 && targetMs===todayCutoffMs && nowSydneyMs<todayCutoffMs;
      labelEl.textContent = sameDay ? 'for same day dispatch' : 'for next business day dispatch';
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function findAndInit(){
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', findAndInit);
  document.addEventListener('shopify:section:load', findAndInit);
})();
